/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsPreview,
    SharedserviceMelcoModelsPreviewFromJSON,
    SharedserviceMelcoModelsPreviewFromJSONTyped,
    SharedserviceMelcoModelsPreviewToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsAlphabetListItem
 */
export interface SharedserviceMelcoModelsAlphabetListItem {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsAlphabetListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsAlphabetListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsAlphabetListItem
     */
    type?: string | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsPreview>}
     * @memberof SharedserviceMelcoModelsAlphabetListItem
     */
    previews?: Array<SharedserviceMelcoModelsPreview> | null;
}

export function SharedserviceMelcoModelsAlphabetListItemFromJSON(json: any): SharedserviceMelcoModelsAlphabetListItem {
    return SharedserviceMelcoModelsAlphabetListItemFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsAlphabetListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsAlphabetListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'previews': !exists(json, 'previews') ? undefined : (json['previews'] === null ? null : (json['previews'] as Array<any>).map(SharedserviceMelcoModelsPreviewFromJSON)),
    };
}

export function SharedserviceMelcoModelsAlphabetListItemToJSON(value?: SharedserviceMelcoModelsAlphabetListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'type': value.type,
        'previews': value.previews === undefined ? undefined : (value.previews === null ? null : (value.previews as Array<any>).map(SharedserviceMelcoModelsPreviewToJSON)),
    };
}


